import { DB_CONST } from './../class/constants'

const PT_PRODUCTS = {
  types: {
    [DB_CONST.PRODUCTS_TYPE[0]]: 'Consulta Completa',
    [DB_CONST.PRODUCTS_TYPE[1]]: 'Consulta Cadastral',
    [DB_CONST.PRODUCTS_TYPE[2]]: 'Flag Restritivo',
    [DB_CONST.PRODUCTS_TYPE[3]]: 'Detalhes Restritivos',
    [DB_CONST.PRODUCTS_TYPE[4]]: 'Consulta Score'
  },
  error: {
    title: 'Não foi possível efetuar a consulta.',
    caption: 'No momento o CPF / CNPJ informado se encontra indisponível para consulta.',
    info: 'Esta consulta não gerou custos.',
    noBalance: 'Saldo insuficiente! Você não possui os créditos necessários em sua conta.',
    rechargeHereBtn: 'Recarregar Créditos'
  },
  moreDetails: 'Ver detalhes',
  [DB_CONST.PRODUCTS.CPF_COMPLETE]: {
    name: 'Consulta Completa',
    type: 'Completa'
  },
  [DB_CONST.PRODUCTS.CPF_BASIC]: {
    name: 'Consulta Cadastral',
    type: 'Cadastral',

    resultTitle: 'Dados Cadastrais',
    moreDetails: 'Mais detalhes',
    // Items
    Name: 'Nome completo:',
    OtherName: 'Outros nomes:',
    CPFStatusFull: 'Situação cadastral:',
    CPF: 'CPF:',
    DOBFull: 'Data de nascimento:',
    Age: 'Idade',
    GenderFull: 'Sexo:',
    MotherName: 'Nome da mãe:',
    Address: 'Endereço atual:',
    OtherAddress: 'Outros endereços:',
    PhoneNumber: 'Telefone atual:',
    OtherPhoneNumber: 'Outros Telefones:',
    MobilePhoneNumber: 'Celular atual:',
    OtherMobilePhoneNumber: 'Outros celulares:',
    Partnerships: {
      title: 'Participações em Empresas:',
      DateStartPartner: 'Data de Entrada',
      Type: 'Tipo',
      PercentParticipation: 'Percentual de Participação'
    },
    Email: 'Email:',
    OtherEmail: 'Outros Emails:'
  },
  [DB_CONST.PRODUCTS.CPF_RESTRICT_FLAG]: {
    name: 'Flag Restritivo',
    type: 'Flag Restritivo',
  },
  [DB_CONST.PRODUCTS.CPF_RESTRICT_DETAIL]: {
    name: 'Detalhes Restritivos',
    type: 'Detalhes Restritivos',

    resultTitle: 'Pendências financeiras',
  },
  [DB_CONST.PRODUCTS.CPF_SCORE]: {
    name: 'Consulta Score',
    type: 'Score',

    // Details
    resultTitle: 'Score',
    Score: 'Score:',
    ProfileScore: 'Relacionamento com o Mercado',
    PaymentCommitmentScore: 'Pontualidade do Pagador',
    noData: 'Sem dados',

    just: 'Justificativas:',

    scoreRiscTitle: 'Risco de crédito:',
    scoreRiscCaptionLow: 'Capacidade de pagamento menor do que a média da população brasileira.',
    scoreRiscCaptionMed: 'Capacidade de pagamento próxima a média da população brasileira.',
    scoreRiscCaptionHigh: 'Capacidade de pagamento maior do que a média da população brasileira.',

    indicatorsTitle: 'Indicadores:',

    paymentProbTitle: 'Probabilidade de pagamento:',
    paymentProbCaption: 'A chance deste consumidor não pagar nos próximos meses é de {{prob}}%.',

    info1: 'Dados utilizados para calcular o Score:',
    info2: '\t1. Dados do Cadastro Positivo',
    info3: '\t2. Dados cadastrais',
    info4: 'O consumidor não possui histórico de pendências financeiras em nossa base de dados.',
    info5: 'Podem existir pendências não informadas. Nenhum relatório de crédito do mercado possui mais do que 50% das pendências existentes em seu banco de dados. Por isso, acreditamos na qualidade do score calculado com dados positivos.',
  },
  [DB_CONST.PRODUCTS.CNPJ_COMPLETE]: {
    name: 'Consulta Completa',
    type: 'Completa',
  },
  [DB_CONST.PRODUCTS.CNPJ_BASIC]: {
    name: 'Consulta Cadastral',
    type: 'Cadastral',

    // Details
    resultTitle: 'Dados Cadastrais',
    moreDetails: 'Mais detalhes',

    CompanyName: 'Razão Social:',
    TradeName: 'Nome Fantasia:',
    CompanyStatus: 'Situação Cadastral:',
    CNPJ: 'CNPJ:',
    DateFoundationFull: 'Data de Fundação:',
    LegalType: 'Natureza Jurídica:',
    Address: 'Endereço',
    OtherAddress: 'Outros endereços:',
    PhoneNumber: 'Telefone atual:',
    OtherPhoneNumber: 'Outros Telefones:',
    Email: 'Email:',
    OtherEmail: 'Outros Emails:',
    CountBranches: 'Quantidade de Filiais:',
    Nire: 'NIRE:',
    MainActivity: 'CNAE Primário:',
    MainActivityDescription: "Descrição CNAE Primário:",
    SecondaryActivity: 'CNAE Secundário:',
    SecondaryActivityDescription: 'Descrição  CNAE Secundário:',
    warningCNPJNotExists: 'Atenção! Este CNPJ é válido porém não existe.'
  },
  [DB_CONST.PRODUCTS.CNPJ_RESTRICT_FLAG]: {
    name: 'Flag Restritivo',
    type: 'Flag Restritivo',
  },
  [DB_CONST.PRODUCTS.CNPJ_RESTRICT_DETAIL]: {
    name: 'Detalhes Restritivos',
    type: 'Detalhes Restritivos',

    // Consult Details
    resultTitle: 'Pendências financeiras',
  },
  [DB_CONST.PRODUCTS.CNPJ_SCORE]: {
    name: 'Consulta Score',
    type: 'Consulta Score',
    // Details
    resultTitle: 'Score',
    scoreRiscTitle: 'Risco de crédito:',
    scoreRiscCaption: 'De acordo com o perfil do CNPJ consultado e seu principal sócio, o risco de não pagamento dos compromissos financeiros da empresa é estatisticamente {{risc}}.',

    just: 'Justificativas:',

    scoreRiscVeryHigh: 'MUITO ALTO',
    scoreRiscHigh: 'ALTO',
    scoreRiscMed: 'MÉDIO',
    scoreRiscLow: 'BAIXO',
    scoreRiscVeryLow: 'MUITO BAIXO',

    info1: 'Dados utilizados para calcular o Score:',
    info2: 'O Score da empresa leva em consideração os dados da empresa e de seu sócio principal.',
    info3: 'CPF do sócio principal: ',

    scoreError: 'O cálculo de Score pode ter sido afetado:'
  },

  // Used on Both Products CPF / CNPJ Negative
  Negative: {

    noFlag: 'Este CPF/CNPJ não possui dados restritivos.',
    yesFlag: 'Este CPF/CNPJ possui os dados restritivos listados abaixo.',

    pendencies: '{{pendencies}} pendências',

    // Ccf Fields for both CPF and CNPJ
    CcfApontamentos: 'Cheques sem fundo (CCF)',
    CcfTable: {
      title: 'Detalhes - Cheques sem fundo (CCF)',
      CountBounce: 'N. de ocorrências',
      CpfCnpj: 'CPF / CNPJ',
      DateLastBounceFull: 'Última ocorrência',
      EntityTypeFull: 'Pessoa',
      ReasonBounceFull: 'Motivo da dívida',
      ReportingBranchPrefix: 'Agência bancária',
      ReportingCodeBank: 'Código do Banco',
    },

    // Lawsuit Fields for both CPF and CNPJ
    LawSuitApontamentos: 'Ações Judiciais',
    LawSuitTable: {
      title: 'Detalhes - Ações Judiciais',
      ProcessNumber: 'Número Principal do processo',
      ProtocolNumber: 'Número Protocolo',
      Comarca: 'Comarca',
      Forum: 'Forum',
      Vara: 'Vara',
      Name: 'Nome parte Ré',
      DateDistributionFull: 'Data de Ajuizamento',
      ProcessType: 'ProcessType',
      CurrentStatus: 'Status do andamento',
      AmountLawsuit: 'Valor da Ação (R$)',
      ProcessAuthor: 'Nome da parte Autora',
      City: 'Cidade',
      State: 'Estado',
      JusticeType: 'Tipo de Justiça',
      CpfCnpj: 'CPF / CNPJ do Réu',

      // Unique to CPF
      EntityTypeFull: 'Tipo de Pessoa do Réu',
      SimilarityIndex: 'Índice de Similaridade',
      IdConfidence: 'Critérios de Atribuição do Documento ao Réu',
      RegisterId: 'ID do Registro',
      RegisterType: 'Tipo do registro',
      OriginSourceFull: 'Fonte de Captação',
      DateProcessedFull: 'Data de Captação',
    },

    // Apontamentos Fields for both CPF and CNPJ
    Apontamentos: 'Apontamentos',
    ApontTable: {
      title: 'Detalhes - Apontamentos',
      CNPJ: 'CNPJ da Empresa negativadora',
      CNPJMask: 'CNPJ da Empresa negativadora',
      CompanyName: 'Nome da Empresa negativadora',
      NatureFull: 'Natureza da operação',
      Amount: 'Quantidade (R$)',
      ContractNumber: 'Numero contrato',
      ParticipantTypeFull: 'Tipo do participante',
      ApontamentoStatusFull: 'Status',
      DateOccurredFull: 'Data da ocorrência',
      DateIncludedFull: 'Data de inclusão',
      State: 'Estado',
      City: 'Cidade',
    }
  }
}

export default PT_PRODUCTS;